import axios from 'axios';
import getConfig from '../getConfig';
import {Middleware} from './performQuery';
import {BEWpArticle} from './types';

const {api} = getConfig();

/**
 * Since the response is wrapped in a nested object, this middleware returns the relevant data only
 * @param response
 */
const getRoot: Middleware = (response): unknown => {
  // console.log("first", response.data[0].group.map((item) => item ))
  return response.data[0].group;}

/**
 * A thunk returning a query for Wordpress articles.
 *
 * @param middleware
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const query = (middleware: Middleware = getRoot) => (): Promise<any> =>
  axios({
    url: `${api.wordpress.root}`,
    method: 'GET',
    params: {
      api_key: `${api.wordpress.api_key}`
    },
    headers: {
      'Content-Type': 'application/json',
    },

  }).then(middleware);

export const getTeaserWpArticles = (): Promise<BEWpArticle[]> => query()();

export default {getTeaserWpArticles};
